import { render, staticRenderFns } from "./stockPanelByShop.vue?vue&type=template&id=b5410060&scoped=true&"
import script from "./stockPanelByShop.vue?vue&type=script&lang=ts&"
export * from "./stockPanelByShop.vue?vue&type=script&lang=ts&"
import style0 from "./stockPanelByShop.vue?vue&type=style&index=0&id=b5410060&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5410060",
  null
  
)

export default component.exports